<form class="hx-form" nz-form [nzLayout]="'vertical'" [formGroup]="formStoreInfo" *transloco="let tr; prefix: 'stores'; scope: 'stores'">
  <div nz-row [nzGutter]="8">
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.curbsidePickupRadius')}} (метры)</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="curbsidePickupRadius" type="number"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.curbsidePickupEnabled')}}</nz-form-label>
        <nz-form-control>
          <nz-radio-group formControlName="curbsidePickupEnabled">
            <label nz-radio nzValue="true">{{'yes' | transloco}}</label>
            <label nz-radio nzValue="false">{{'no' | transloco}}</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row [nzGutter]="8">
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.dgisUrl')}}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="dgisUrl" type="text"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.yandexUrl')}}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="yandexUrl" type="text"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.mapType')}}</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="mapType">
            <nz-option nzLabel="GOOGLE" nzValue="GOOGLE"></nz-option>
            <nz-option nzLabel="DGIS" nzValue="DGIS"></nz-option>
            <nz-option nzLabel="YANDEX" nzValue="YANDEX"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row [nzGutter]="8">
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.onlineBeforeCloseLimit')}}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="onlineBeforeCloseLimit" type="number"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.locationHint')}}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="locationHint" type="text"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.switchDate')}}</nz-form-label>
        <nz-form-control>
          <nz-date-picker formControlName="switchDate"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row [nzGutter]="8">
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.googlePlaceType')}}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="googlePlaceType" type="text"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.googlePlaceId')}}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="googlePlaceId" type="text"/>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row [nzGutter]="8">
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.ext_1C_code')}}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="ext_1C_code" type="text"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.signUserId')}}</nz-form-label>
        <nz-form-control>
          <hx-user-select formControlName="signUserId"></hx-user-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row [nzGutter]="8">
    <div nz-col>
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.onlinePaymentRequired')}}</nz-form-label>
        <nz-form-control>
          <nz-radio-group formControlName="onlinePaymentRequired">
            <label nz-radio nzValue="true">{{'yes' | transloco}}</label>
            <label nz-radio nzValue="false">{{'no' | transloco}}</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col class="hx-col-3">
      <nz-form-item>
        <nz-form-label>{{tr('form.store-info.referrers')}}</nz-form-label>
        <nz-select formControlName="referrers" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch [nzMode]="'multiple'">
          <nz-option *ngFor="let referrer of referrers" [nzDisabled]="!referrer.enabled" [nzLabel]="referrer.code" [nzValue]="referrer.code"></nz-option>
        </nz-select>
      </nz-form-item>
    </div>
  </div>
</form>
